<template>
  <p class="small">{{ $t('LoanApplicationTimeline.verificationIsInProgress') }}</p>
</template>
<script>
export default {
  name: 'IdentityVerificationInProgressComponent'
}
</script>
